<div class="modal-header">
  <h5 class="modal-title">
    <i class="far fa-calendar-alt"></i> <ng-container i18n>Blackout Dates</ng-container> - {{ discountName }}
  </h5>
  <a (click)="close()" class="cstm-close">
    <span class="far fa-times"></span>
  </a>
</div>
<div class="modal-body">
  <p class="text-sm text-muted" i18n>
    Airbnb does not apply the discount on blackout dates. Click a date to add or remove it. Shift+click another date to
    do the same for all dates in between.
  </p>
  <div class="row">
    <div class="col-sm-7">
      <div
        class="blackout-calendar border rounded"
        [style.opacity]="isLoading ? 0.5 : 1"
        [style.pointerEvents]="isLoading ? 'none' : 'auto'"
        (mousedown)="shiftKey = $event.shiftKey"
        (keydown)="shiftKey = $event.shiftKey"
      >
        <mat-calendar
          [startAt]="minDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [dateClass]="dateClass"
          (selectedChange)="onDateClick($event)"
        ></mat-calendar>
      </div>
    </div>
    <div class="col-sm-5">
      <div class="text-sm text-semi-bold" i18n>Dates Left</div>
      <div
        *ngFor="let quota of quotas"
        class="d-flex justify-content-between text-sm"
        [class.text-danger]="quota.left <= 0"
      >
        <span>{{ quota.year }}</span>
        <span i18n>{{ quota.left }} of {{ quota.total }}</span>
      </div>

      <div class="text-sm text-semi-bold mt-3" i18n>Selected Dates</div>
      <div class="blackout-ranges">
        <div *ngIf="!ranges.length" class="text-sm text-muted" i18n>None. The discount applies to all dates.</div>
        <div *ngFor="let range of ranges" class="d-flex align-items-center text-sm">
          <span>{{ range.label }}</span>
          <span *ngIf="range.dates.length > 1" class="text-muted ml-1" i18n>({{ range.dates.length }} dates)</span>
          <button
            *ngIf="range.to >= today"
            type="button"
            class="btn btn-link btn-sm p-0 ml-auto"
            [disabled]="isLoading"
            (click)="removeRange(range)"
            matTooltip="Remove these dates"
            i18n-matTooltip
          >
            <i class="far fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <span *ngIf="datesToAdd.length || datesToRemove.length" class="text-sm text-muted mr-auto" i18n>
    Not saved: {{ datesToAdd.length }} to add, {{ datesToRemove.length }} to remove.
  </span>
  <button (click)="close()" type="button" class="btn btn-light" [disabled]="isLoading">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    (click)="save()"
    type="button"
    class="btn btn-secondary-info create-btn"
    [disabled]="isLoading || (!datesToAdd.length && !datesToRemove.length)"
  >
    <i class="fal" [ngClass]="isLoading ? 'fa-spin fa-spinner' : 'fa-save'"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
